import { FeatureType } from '@shared/interfaces/feedback';
import { featureToFormDataMap, radioDefaultValues, wildcardId } from '../../../utils/feedback/feedback';

export const mapFeedbackId = (feature: FeatureType, questionId: string) => {
  const questionsData = featureToFormDataMap[feature].questions.flat();
  const questionWithoutOptions = questionsData.find((q) => q.id === questionId);
  if (questionWithoutOptions?.title) {
    return questionWithoutOptions.title;
  }

  for (const q of questionsData) {
    const option = q.options?.find((o) => o.id === questionId);
    if (option) {
      return `${q.title} - ${option.label}`;
    }
  }

  return `Question ${questionId} cannot be found in ${JSON.stringify(questionsData)}`;
};

export const mapAnswerId = (feature: FeatureType, questionId: string, answers: string[]) => {
  if (answers === null) return [];
  const questionsData = featureToFormDataMap[feature].questions.flat();
  const question = questionsData.find((q) => q.id === questionId || q.options?.some((o) => o.id === questionId));
  if (!question?.options) {
    return answers.map((answer) => (answer.startsWith(wildcardId) ? answer.substring(wildcardId.length) : answer));
  }
  return answers.map((answer) => {
    if (answer.startsWith(wildcardId)) return answer.substring(wildcardId.length);
    if (question.type === 'radio-block') {
      const defaultMatch = radioDefaultValues.find((dv) => dv.id === answer);
      if (defaultMatch) return defaultMatch.label;

      const valueMatch = question.values?.find((v) => v.id === answer);
      if (valueMatch) return valueMatch.label;
    }
    const optionsMatch = question.options?.find((o) => o.id === answer);
    if (optionsMatch) return optionsMatch.label;

    return `Answer ${answer} cannot be found in ${JSON.stringify(questionsData)}`;
  });
};
